import React from "react";

export function VmSvgImage(props) {
  return (
    <img
      src={`https://cdn.venuemonk.com/images/icons/${props.iconName}.svg`}
      className={props.targetClass ? props.targetClass : "no-class"}
      alt="alt-text"
    />
  );
}

export default VmSvgImage;
